
export const FIRST_FLOOR_IMG_URL = "https://www.uom.gr/site/images/katopseis/esot_protos.jpg"
export const MEZZANINE_FLOOR_IMG_URL = "https://www.uom.gr/site/images/katopseis/esot_imiorofos.jpg"
export const GROUND_FLOOR_IMG_URL = "https://www.uom.gr/site/images/katopseis/esot_isogeio.jpg"
//Applied Informatics and Economics
export const SECOND_FLOOR_CD_IMG = "https://opensource.uom.gr/uom_maps/2gd.jpg"
export const THIRD_FLOOR_CD_IMG = "https://opensource.uom.gr/uom_maps/3gd.jpg"
export const FOURTH_FLOOR_CD_IMG = "https://opensource.uom.gr/uom_maps/4gd.jpg"
export const FIFTH_FLOOR_CD_IMG = "https://opensource.uom.gr/uom_maps/5gd.jpg"
//Business Admininstration and Accounting & Finance
export const SECOND_FLOOR_HT_IMG = "https://opensource.uom.gr/uom_maps/2ht.jpg"
export const THIRD_FLOOR_HT_IMG = "https://opensource.uom.gr/uom_maps/3ht.jpg"
export const FOURTH_FLOOR_HT_IMG = "https://opensource.uom.gr/uom_maps/4ht.jpg"
// Balkan Studies and European Studies and Education and Music
export const SECOND_FLOOR_KZ_IMG = "https://opensource.uom.gr/uom_maps/2kz.jpg"
export const THIRD_FLOOR_KZ_IMG = "https://opensource.uom.gr/uom_maps/3kz.jpg"
export const FOURTH_FLOOR_KZ_IMG = "https://opensource.uom.gr/uom_maps/4kz.jpg"

